export const GET_SEGMENTS_WATCHER = "app/NewMeasure/GET_SEGMENTS_WATCHER"
export const GET_SEGMENTS_SUCCESS = "app/NewMeasure/GET_SEGMENTS_SUCCESS"
export const GET_SEGMENTS_FAILED = "app/NewMeasure/GET_SEGMENTS_FAILED"

export const GET_SURVEY_TYPES_WATCHER =
  "app/NewMeasure/GET_SURVEY_TYPES_WATCHER"
export const GET_SURVEY_TYPES_SUCCESS =
  "app/NewMeasure/GET_SURVEY_TYPES_SUCCESS"
export const GET_SURVEY_TYPES_FAILED = "app/NewMeasure/GET_SURVEY_TYPES_FAILED"

export const GET_SCOPE_TYPES_WATCHER = "app/NewMeasure/GET_SCOPE_TYPES_WATCHER"
export const GET_SCOPE_TYPES_SUCCESS = "app/NewMeasure/GET_SCOPE_TYPES_SUCCESS"
export const GET_SCOPE_TYPES_FAILED = "app/NewMeasure/GET_SCOPE_TYPES_FAILED"

export const CREATE_MEASUREMENT_WATCHER =
  "app/NewMeasure/CREATE_MEASUREMENT_WATCHER"
export const CREATE_MEASUREMENT_SUCCESS =
  "app/NewMeasure/CREATE_MEASUREMENT_SUCCESS"
export const CREATE_MEASUREMENT_FAILED =
  "app/NewMeasure/CREATE_MEASUREMENT_FAILED"

export const GET_ORGANIZATION_SURVEYS_WATCHER =
  "app/NewMeasure/GET_ORGANIZATION_SURVEYS_WATCHER"
export const GET_ORGANIZATION_SURVEYS_SUCCESS =
  "app/NewMeasure/GET_ORGANIZATION_SURVEYS_SUCCESS"
export const GET_ORGANIZATION_SURVEYS_FAILED =
  "app/NewMeasure/GET_ORGANIZATION_SURVEYS_FAILED"

export const GET_SEGMENTS_SURVEYS_WATCHER =
  "app/NewMeasure/GET_SEGMENTS_SURVEYS_WATCHER"
export const GET_SEGMENTS_SURVEYS_SUCCESS =
  "app/NewMeasure/GET_SEGMENTS_SURVEYS_SUCCESS"
export const GET_SEGMENTS_SURVEYS_FAILED =
  "app/NewMeasure/GET_SEGMENTS_SURVEYS_FAILED"
